import * as React from 'react';

const styles = require('./OptInScene.scss');
const classNames = require('classnames/bind').bind(styles);

function WelcomeScene(props: {}) {
    return (
        <div>
            <div className={classNames('prop', 'rossini-morning')} />
            <div className={classNames('prop', 'logo')} />
            <div className={classNames('prop', 'cloud', 'alpha')} />
            <div className={classNames('prop', 'cloud', 'beta')} />
            <div className={classNames('prop', 'cloud', 'gamma')} />
        </div>
    );
}
export default WelcomeScene;
